<template>
  <div class="row">
    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8">
      <c-card title="법규별 규제사항" class="cardClassDetailForm">
        <template slot="card-description">
          <span style="color: tomato; margin-left: 10px">
            {{
              "주황색 테두리로 강조된 규제 항목은 사용자가 직접 확인을 하여 체크를 하셔야 합니다."
            }}
          </span>
        </template>
        <template slot="card-button">
          <q-btn-group outline>
            <c-btn
              v-show="editable"
              label="이력보기"
              icon="restore"
              @btnClicked="openHistory"
            />
            <c-btn
              v-if="editable"
              label="규제항목 기준값 조회"
              icon="help"
              @btnClicked="openChemQuantity"
            />
            <c-btn
              v-if="editable"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="saveData"
              mappingType="PUT"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveInfo"
              @btnCallback="saveCallback"
            />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-12 divchklaw" v-for="(item, idx) in bills" :key="idx">
            <div class="lawspan">{{ item.regulationBillName }}</div>
            <q-checkbox
              v-for="(regul, _idx) in item.reguls"
              :key="_idx"
              class="customqcbox"
              dense
              color="orange-custom"
              true-value="Y"
              false-value="N"
              :disable="!editable"
              :label="regul.regulatedItemName"
              v-model="regul.val"
              :class="{
                'highlight-checkbox': highlightCodes.includes(
                  regul.regulatedItemCd
                ),
              }"
            />
          </div>
        </template>
      </c-card>
      <c-dialog :param="popupOptions"></c-dialog>
    </div>

    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <c-card title="규제 선택 참고사항" class="cardClassDetailForm">
        <template slot="card-detail">
          <div class="cardContents">
            <ul>
              <li>
                <div class="law-title">1. 산업안전보건법</div>
                <div class="law-desc">
                  📌 <b>[제조금지/허가/관리대상 등]</b>은
                  <b>함유량(%)</b> 기준을 만족해야 합니다.<br />
                  📌 <b>[노출기준/허용기준]</b>은 <b>TWA/STEL</b> 노출 농도를
                  기준으로 합니다.<br />
                  📌 <b>[PSM 대상물질]</b>은 제조/취급/저장
                  <b>일일 규정수량</b>을 기준으로 합니다.
                </div>
              </li>
              <li>
                <div class="law-title">2. 화학물질관리법</div>
                <div class="law-desc">
                  📌 <b>[제한/금지물질]</b>은 <b>함유량(%)</b> 기준을
                  따릅니다.<br />
                  📌 <b>[사고대비/유독물질(급성 등)]</b>은
                  <b>함유량과 규정수량</b>을 모두 확인해야 합니다.<br />
                  📌 <b>[PRTR 그룹]</b>은 <b>함유량과 연간 취급량</b> 기준에
                  따라 체크됩니다.
                </div>
              </li>
              <li>
                <div class="law-title">3. 위험물안전관리법</div>
                <div class="law-desc">
                  📌 <b>[제1류 ~ 제6류]</b>는 물질별 총 허가배수를 직접 확인하여
                  체크 바랍니다.<br />
                  <!-- [위안법 물질 허가배수 관리] 메뉴에서 확인하세요.<br /> -->
                  📌 <b>[제4류, 제5류]</b>는 수용성/비수용성 여부에 따라
                  기준값이 달라지므로 주의 바랍니다.
                </div>
              </li>
              <li>
                <div class="law-title">4. 폐기물관리법</div>
                <div class="law-desc">
                  📌 <b>[폐유기용제/지정폐기물]</b>은 함유량 및 성상 기준에 따라
                  체크합니다.
                </div>
              </li>
              <li>
                <div class="law-title">5. 기타 환경 법령 (정량값 없음)</div>
                <div class="law-desc">
                  📌 <b>[고압가스, 대기, 수질, 토양, 악취, 오존 등]</b>은 별도의
                  정량값 입력 없이, 해당 물질이
                  <b>규제 목록에 등재되어 있는지</b> 여부만 확인하여 체크합니다.
                </div>
              </li>
              <li>
                <div class="law-title">※ 주의사항</div>
                <div class="law-desc">
                  📌
                  <span style="color: tomato; font-weight: bold"
                    >주황색 테두리</span
                  >로 강조된 항목은 시스템 자동 판단이 어려울 수 있으므로,
                  사용자가 반드시 규제 여부를 직접 확인해야 합니다.
                </div>
              </li>
            </ul>
          </div>
        </template>
      </c-card>
    </div>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";

export default {
  name: "chemLaw",
  props: {
    // Vue 2 컨벤션에 따른 props 명칭 유지
    param: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: "",
        plantCd: null,
      }),
    },
    searchFlag: {
      type: Object,
      default: () => ({
        chemMsds: "",
      }),
    },
    isSearch: null,
  },
  data() {
    return {
      reguls: [],
      bills: [],
      saveData: {
        mdmChemMaterialId: "",
        regUserId: "",
        reguls: [],
      },
      editable: true,
      isSave: false,
      listUrl: "",
      saveUrl: "",
      // Vue 3 소스의 강조 코드 반영
      highlightCodes: [
        "D14010005",
        "D14010004",
        "D14010006",
        "D14010001",
        "D14010002",
        "D14010003",
      ],
      popupOptions: {
        isFull: false,
        width: "100%",
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  watch: {
    // searchFlag 감시 로직 유지
    "searchFlag.chemMsds"() {
      this.getList();
    },
    isSearch: {
      handler: function () {
        this.getList();
      },
      deep: true,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.mam.chem.materialRegul.list.url;
      this.saveUrl = transactionConfig.mdm.mam.chem.materialRegul.save.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = {
        mdmChemMaterialId: this.param.mdmChemMaterialId,
      };
      this.$http.request((_result) => {
        this.reguls = _result.data;

        this.bills = [];
        if (this.reguls && this.reguls.length > 0) {
          // bills 구조 생성
          this.bills = this.$_.map(this.reguls, (value) => {
            return {
              regulationBillCd: value["regulationBillCd"],
              regulationBillName: value["regulationBillName"],
              reguls: [],
            };
          });
          // 법규코드 중복 제거
          this.bills = this.$_.uniqBy(this.bills, (item) => {
            return item.regulationBillCd;
          });

          // 법규별 규제항목 매핑 및 순번 처리
          let i = 1;
          this.$_.forEach(this.bills, (bill) => {
            bill.regulationBillName = i + ". " + bill.regulationBillName;
            this.$set(
              bill,
              "reguls",
              this.$_.filter(this.reguls, {
                regulationBillCd: bill.regulationBillCd,
              })
            );
            i++;
          });
        }
      });
    },
    // 규제항목 기준값 조회 팝업
    openChemQuantity() {
      this.popupOptions.title = "규제항목 기준값 조회";
      this.popupOptions.param = {
        mdmChemMaterialId: this.param.mdmChemMaterialId,
        plantCd: this.param.plantCd,
      };
      this.popupOptions.target = () => import("./chemQuantity.vue");
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = "80%";
      this.popupOptions.closeCallback = this.closePopup;
    },
    // 이력보기 팝업
    openHistory() {
      this.popupOptions.title = "화학자재 규제사항 이력 목록";
      this.popupOptions.param = {
        mdmChemMaterialId: this.param.mdmChemMaterialId,
      };
      this.popupOptions.target = () => import("./chemLawHistory.vue");
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = "40%";
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    saveInfo() {
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM",
        message: "MSGSAVE",
        type: "info",
        confirmCallback: () => {
          this.$set(
            this.saveData,
            "mdmChemMaterialId",
            this.param.mdmChemMaterialId
          );
          this.$set(this.saveData, "regUserId", this.$store.getters.token); // 또는 userStore의 id
          this.$set(
            this.saveData,
            "reguls",
            this.$_.filter(this.reguls, { val: "Y" })
          );
          this.isSave = !this.isSave;
        },
        cancelCallback: () => {},
      });
    },
    saveCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      // saveData 초기화
      this.saveData = {
        mdmChemMaterialId: "",
        regUserId: "",
        reguls: [],
      };
      this.getList();
    },
  },
};
</script>

<style>
/* Vue 2 프로젝트 스타일 컨벤션 유지 */
.lawspan {
  color: #0072c6 !important;
  font-size: 14px !important;
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
}
.divchklaw {
  margin-bottom: 15px;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.customqcbox {
  margin-right: 8px;
}

/* 도움말 카드 스타일 (Vue 3 소스 반영) */
.cardContents {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background-color: #fefefe;
  padding: 15px;
  color: #333;
  line-height: 1.6;
}
.cardContents ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
.cardContents li {
  background: #f5f8fa;
  border-left: 5px solid #3498db;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
}
.law-title {
  font-weight: bold;
  font-size: 15px;
  color: #2c3e50;
  margin-bottom: 3px;
}
.law-desc {
  font-size: 13px;
  color: #555;
}

/* 직접 확인 항목 하이라이트 */
.highlight-checkbox {
  border: 2px solid tomato !important;
  border-radius: 6px;
  padding: 2px;
  background-color: #fffdf5;
}
</style>
